/* eslint-disable react/prop-types */
import React, { useContext } from 'react';

import Typography from 'core/ui/Typography';
import Box from 'core/ui/Box';
import { Collapse, makeStyles } from '@material-ui/core';
import { DrawContext } from 'core/contexts';
import MIcon from 'core/ui/MIcon';
import Divider from 'core/ui/Divider';
import Paper from 'core/ui/Paper';
import useMenuCollapse from 'core/utils/useMenuCollapse';
import { ButtonSelect, ButtonRemoveCourt } from 'core/ui/Button';
import { OpenWith, RemoveCircle } from '@material-ui/icons';
import Form from './Form';

const useStyles = makeStyles(() => ({
  tab: {
    position: 'relative',
  },
  buttonRemove: {
    position: 'absolute',
    top: 12,
    right: 50,
  },
  buttonSelect: {
    position: 'absolute',
    top: 12,
    right: 90,
  },
}));

const ItemList = ({ text, index, removeElement, selectElement }) => {
  const classes = useStyles();
  const { isOpen, collapseMenu } = useMenuCollapse();

  const open = isOpen(text.id);

  return (
    <Paper mb={1} className={classes.tab}>
      <Box
        p={3}
        display="flex"
        alignItems="center"
        className="hover"
        onClick={() => collapseMenu(text.id, !open)}
      >
        <Box flexGrow={1}>
          <Typography font="bold" size="small">
            {text.text || `TEXT - ${index + 1}`}
          </Typography>
        </Box>
        <Box onClick={() => collapseMenu(text.id, !open)}>
          <MIcon icon={open ? 'keyboard_arrow_down' : 'keyboard_arrow_right'} />
        </Box>
      </Box>

      <Box className={classes.buttonSelect}>
        <ButtonSelect onClick={() => selectElement(text, 'text')}>
          <OpenWith fontSize="small" />
        </ButtonSelect>
      </Box>

      <Box className={classes.buttonRemove}>
        <ButtonRemoveCourt onClick={() => removeElement(text, 'text')}>
          <RemoveCircle fontSize="small" />
        </ButtonRemoveCourt>
      </Box>
      <Box>
        {open && <Divider mx={3} />}
        <Collapse in={open}>
          <Box p={3}>
            <Form current={text} callback={() => {}} />
          </Box>
        </Collapse>
      </Box>
    </Paper>
  );
};

const ListTexts = () => {
  const { texts, removeElement, selectElement } = useContext(DrawContext);

  return (
    <Box mb={5}>
      {texts &&
        texts.map((text, index) => (
          <ItemList
            key={index.toString()}
            text={text}
            removeElement={removeElement}
            selectElement={selectElement}
            index={index}
          />
        ))}
    </Box>
  );
};

export default ListTexts;
